import { useCallback } from 'react';
import { InactiveTeamListItem, HeaderListItem } from './types';
import { COLUMNS, ROW_TYPES } from './tableConfig';
import useTeams from 'hooks/useTeams';
import useAppNavigation from 'hooks/useAppNavigation';
import { CellWithBorderClassNames } from 'shared/styles';

const cellClassNameByColumns: Record<string, CellWithBorderClassNames[]> = {
  [COLUMNS.TEAM_ID]: ['sticky', 'zindex3'],
  [COLUMNS.TEAM_NAME]: ['sticky', 'zindex3'],
  [COLUMNS.CREATED_AT]: ['sticky', 'zindex3'],
  [COLUMNS.TAGS]: ['sticky', 'zindex3'],
  [COLUMNS.MEMBERS]: ['sticky', 'zindex3'],
  [COLUMNS.CSM]: ['sticky', 'zindex3'],
  [COLUMNS.LAST_ACTIVITY]: ['sticky', 'zindex3'],
};

const headerListItem = {
  id: ROW_TYPES.HEADER,
  rowType: ROW_TYPES.HEADER,
  disableRowHover: false,
  isStickyHeader: true,
  cellClassNameByColumns,
} as HeaderListItem;

export const useInactiveTeamListItemBuilder = () => {
  const { teamHash } = useTeams();
  const { navigateToTeamProfile } = useAppNavigation();

  const listItemBuilder = useCallback(
    ({ teamIds }: { teamIds: number[] }) => {
      const sortedTeamListItems: InactiveTeamListItem[] = teamIds.flatMap((teamId) => {
        const team = teamHash[teamId];

        if (!team)
          return {
            id: `${teamId}-loading`,
            rowType: ROW_TYPES.LOADER,
            cellClassNameByColumns,
            team: {
              id: teamId,
            },
          };

        return {
          id: team.id.toString(),
          rowType: ROW_TYPES.DATA,
          team,
          hideSelectBox: true,
          onRowClick: () => navigateToTeamProfile({ teamId: team.id }),
          cellClassNameByColumns,
        };
      });

      return [headerListItem, ...sortedTeamListItems];
    },
    [navigateToTeamProfile, teamHash],
  );

  return listItemBuilder;
};
